module.exports = __webpack_public_path__ + "static/media/film_reel-min.51b037ba.jpg";